/* Livish audit fixes (15 Oct 2026). Loaded last, deferred. Remove this file
   and its line in layout/theme.liquid to roll back. */
(function () {
  'use strict';
  var isAr = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;

  /* #7 App popup: hide it on the first page of a visit. */
  try {
    var views = parseInt(sessionStorage.getItem('lv_pv') || '0', 10) + 1;
    sessionStorage.setItem('lv_pv', String(views));
    if (views < 2) {
      document.documentElement.classList.add('lv-first-view');
    }
  } catch (e) {}

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* #2 / A6 Sold-out products move to the end of each product grid
     (collection and search pages; carousels are left alone). */
  function sortGrid(grid) {
    var items = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList.contains('t4s-product');
    });
    if (items.length < 4) return;
    var firstSold = -1, lastIn = -1;
    items.forEach(function (el, i) {
      if (el.classList.contains('is--sold-out')) { if (firstSold < 0) firstSold = i; }
      else lastIn = i;
    });
    if (firstSold < 0 || lastIn < firstSold) return;
    grid.__lvSorting = true;
    items.forEach(function (el) {
      if (el.classList.contains('is--sold-out')) grid.appendChild(el);
    });
    var tail = grid.querySelector(':scope > .t4s-pagination, :scope > [class*="load-more"], :scope > [class*="loadmore"]');
    if (tail) grid.appendChild(tail);
    grid.__lvSorting = false;
  }

  /* Cross-sell before sold-out items: a full-width "Looking for more
     options?" row linking to the categories that the sold-out products
     actually belong to. Categories come from templates/collection.lvcats
     (real product data) and are kept only if they are in the site menu, so
     every link is a real category page with its menu name. Specific
     sub-categories come first; main categories are only a fallback. */
  function cleanText(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
  function normPath(h) {
    var v = (h || '').split('?')[0].split('#')[0];
    try { v = decodeURIComponent(v); } catch (e) {}
    v = v.replace(/^https?:\/\/[^/]+/, '').replace(/\/$/, '').toLowerCase();
    return v;
  }
  function menuIndex() {
    var map = {}, order = 0;
    document.querySelectorAll('#shopify-section-livish-mega-menu a[href*="/collections/"], #shopify-section-mobile-categories-grid a[href*="/collections/"]').forEach(function (a) {
      var k = normPath(a.getAttribute('href'));
      var t = cleanText(a.textContent);
      if (!t || map[k]) return;
      var li = a.closest('li');
      map[k] = { href: a.getAttribute('href'), text: t, leaf: !(li && li.classList.contains('has-children')), order: order++ };
    });
    return map;
  }
  function footerCategories() {
    var out = [];
    var heads = document.querySelectorAll('#t4s-footer .t4s-col-heading');
    for (var k = 0; k < heads.length; k++) {
      if (!/^\s*(الفئات|Categories)\s*$/i.test(heads[k].textContent)) continue;
      var col = heads[k].closest('.t4s-col-inner') || heads[k].parentElement;
      col.querySelectorAll('a[href]').forEach(function (a) {
        var t = cleanText(a.textContent);
        if (t && out.length < 6) out.push({ href: a.getAttribute('href'), text: t });
      });
      break;
    }
    return out;
  }
  function siblingKeys(path, menu) {
    var here = normPath(path), out = [];
    var links = document.querySelectorAll('#shopify-section-livish-mega-menu a[href*="/collections/"], #shopify-section-mobile-categories-grid a[href*="/collections/"]');
    for (var i = 0; i < links.length && !out.length; i++) {
      if (normPath(links[i].getAttribute('href')) !== here) continue;
      var list = links[i].closest('ul');
      if (!list) continue;
      list.querySelectorAll(':scope > li > a[href*="/collections/"]').forEach(function (a) {
        var k = normPath(a.getAttribute('href'));
        if (k !== here && menu[k] && out.indexOf(k) < 0) out.push(k);
      });
    }
    return out;
  }
  var relatedCache = {};
  function loadRelated(path) {
    if (!path || !window.fetch) return Promise.resolve(footerCategories());
    if (relatedCache[path]) return relatedCache[path];
    var relatedPromise;
    var q = '?view=lvcats';
    var pv = location.search.match(/preview_theme_id=\d+/);
    if (pv) q += '&' + pv[0];
    relatedPromise = fetch(path + q, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (txt) {
        if (!txt || /<html/i.test(txt)) return footerCategories();
        var menu = menuIndex(), here = normPath(path);
        var prods = [], cur = [], counts = {};
        txt.split('\n').forEach(function (line) {
          line = line.trim();
          if (line === '--') { if (cur.length) prods.push(cur); cur = []; return; }
          if (!line) return;
          var k = normPath(line.split('|')[0]);
          if (k !== here && menu[k] && cur.indexOf(k) < 0) cur.push(k);
        });
        if (cur.length) prods.push(cur);
        prods.forEach(function (p) { p.forEach(function (k) { counts[k] = (counts[k] || 0) + 1; }); });
        var rank = function (a, b) { return (counts[b] - counts[a]) || (menu[a].order - menu[b].order); };
        /* Take the best sub-category of each sold-out product in turn, so
           every product is represented; categories shared by several
           products come first. */
        var lists = prods.map(function (p) { return p.filter(function (k) { return menu[k].leaf; }).sort(rank); });
        var picked = [];
        while (picked.length < 6) {
          var added = false;
          lists.forEach(function (l) {
            while (l.length && picked.length < 6) {
              var k = l.shift();
              if (picked.indexOf(k) < 0) { picked.push(k); added = true; break; }
            }
          });
          if (!added) break;
        }
        /* Too few? Add this page's sister categories from the menu (same
           menu group), then the shared parent categories. */
        if (picked.length < 4) {
          siblingKeys(path, menu).forEach(function (k) {
            if (picked.length < 6 && k !== here && picked.indexOf(k) < 0) picked.push(k);
          });
        }
        if (picked.length < 3) {
          Object.keys(counts).filter(function (k) { return !menu[k].leaf && picked.indexOf(k) < 0; })
            .sort(rank).slice(0, 6 - picked.length).forEach(function (k) { picked.push(k); });
        }
        var seenText = {}, out = [];
        picked.forEach(function (k) {
          if (seenText[menu[k].text]) return;
          seenText[menu[k].text] = 1;
          out.push({ href: menu[k].href, text: menu[k].text });
        });
        return out.length ? out : footerCategories();
      })
      .catch(function () { return footerCategories(); });
    relatedCache[path] = relatedPromise;
    return relatedPromise;
  }
  /* Which collection a grid shows: the page itself on collection pages,
     otherwise the section's "View all" collection link (if any). */
  function gridCollectionPath(grid) {
    if (/template-collection/.test(document.body.className)) return location.pathname;
    var sec = grid.closest('.shopify-section');
    if (!sec) return null;
    var links = sec.querySelectorAll('a[href*="/collections/"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].closest('.t4s-product')) continue;
      var a = document.createElement('a');
      a.href = links[i].getAttribute('href');
      if (/\/collections\/[^/]+\/?$/.test(a.pathname)) return a.pathname;
    }
    return null;
  }
  function buildMoreOptions(list) {
    var box = document.createElement('div');
    box.className = 'lv-more-options t4s-col-item';
    var title = document.createElement('p');
    title.className = 'lv-more-options__title';
    title.textContent = isAr ? 'تبحث عن خيارات أكثر؟' : 'Looking for more options?';
    var sub = document.createElement('p');
    sub.className = 'lv-more-options__sub';
    sub.textContent = isAr ? 'المنتجات التالية نفدت حالياً. تسوّق من الأقسام المشابهة:' : 'These items are sold out right now. Shop similar categories:';
    var links = document.createElement('div');
    links.className = 'lv-more-options__links';
    list.forEach(function (c) {
      var a = document.createElement('a');
      a.className = 'lv-more-options__btn';
      a.href = c.href;
      a.textContent = c.text;
      links.appendChild(a);
    });
    box.appendChild(title);
    box.appendChild(sub);
    box.appendChild(links);
    return box;
  }
  function placeMoreOptions(grid) {
    var firstSold = grid.querySelector(':scope > .t4s-product.is--sold-out');
    var box = grid.querySelector(':scope > .lv-more-options');
    if (!firstSold) { if (box) box.remove(); return; }
    if (box) {
      if (box.nextElementSibling !== firstSold) {
        grid.__lvSorting = true;
        grid.insertBefore(box, firstSold);
        grid.__lvSorting = false;
      }
      return;
    }
    if (grid.__lvMoreLoading) return;
    var path = /template-search/.test(document.body.className) ? '' : gridCollectionPath(grid);
    if (path === null) return;
    grid.__lvMoreLoading = true;
    loadRelated(path).then(function (list) {
      grid.__lvMoreLoading = false;
      var sold = grid.querySelector(':scope > .t4s-product.is--sold-out');
      if (!list.length || !sold || grid.querySelector(':scope > .lv-more-options')) return;
      grid.__lvSorting = true;
      grid.insertBefore(buildMoreOptions(list), sold);
      grid.__lvSorting = false;
    });
  }

  /* Desktop mega menu: open the first sub-category automatically so the
     full-width panel shows its list straight away. */
  function watchMegaMenu() {
    document.querySelectorAll('.t4s-livish-mega-menu__item.has-dropdown').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        setTimeout(function () {
          if (item.querySelector('.t4s-livish-mega-menu__cascade-track--2.is-visible')) return;
          var first = item.querySelector('.t4s-livish-mega-menu__cascade-panel--root .t4s-livish-mega-menu__cascade-item.has-children > a');
          if (!first) return;
          ['mouseover', 'mouseenter'].forEach(function (t) {
            first.dispatchEvent(new MouseEvent(t, { bubbles: t === 'mouseover' }));
          });
        }, 40);
      });
    });
  }

  /* Category tile sliders with only a few tiles are centred. */
  function centerFewCarousels() {
    document.querySelectorAll('.t4s-list-collections-carousel').forEach(function (c) {
      var vp = c.querySelector('.flickityt4s-viewport');
      var sl = c.querySelector('.flickityt4s-slider');
      if (!vp || !sl) return;
      c.classList.remove('lv-few-cells');
      var total = 0;
      Array.prototype.forEach.call(sl.children, function (e) { total += e.getBoundingClientRect().width; });
      if (total && total <= vp.getBoundingClientRect().width + 1) c.classList.add('lv-few-cells');
    });
  }
  function watchCarousels() {
    /* Measure on the next frame, not while the page is still being built. */
    requestAnimationFrame(centerFewCarousels);
    setTimeout(centerFewCarousels, 800);
    window.addEventListener('load', centerFewCarousels);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(centerFewCarousels, 200); });
  }

  /* Smoother browsing: images start loading about two screens before they
     come into view instead of at the last moment. */
  var lazyOn = false;
  function boostLazy(scope) {
    if (!lazyOn) return;
    (scope || document).querySelectorAll('.lazyloadt4s:not([data-expand])').forEach(function (el) {
      el.setAttribute('data-expand', '1600');
    });
  }
  /* The first screen loads first; the early start for images further down
     begins once the page has loaded (or after 2.5 s at the latest), so those
     images do not compete with the first screen. */
  function watchLazy() {
    function start() {
      if (lazyOn) return;
      lazyOn = true;
      boostLazy();
      var busy = false;
      window.addEventListener('scroll', function () {
        if (busy) return;
        busy = true;
        setTimeout(function () { busy = false; boostLazy(); }, 1000);
      }, { passive: true });
    }
    if (document.readyState === 'complete') start();
    else {
      window.addEventListener('load', start);
      setTimeout(start, 2500);
    }
  }

  /* Long FAQ lists: show the first 5 questions (all closed) and a button
     for the rest. Everything stays in the page, so Google still reads it,
     and the search box still searches every question. */
  function collapseFaqs() {
    document.querySelectorAll('[class^="ai-faq-list-"], [class*=" ai-faq-list-"]').forEach(function (list) {
      if (list.__lvFaq) return;
      list.__lvFaq = true;
      var items = list.querySelectorAll(':scope > [data-faq-item]');
      Array.prototype.forEach.call(items, function (it) {
        if (!it.classList.contains('active')) return;
        var q = it.querySelector('button[aria-expanded="true"]');
        if (q) q.click();
      });
      if (items.length <= 6) return;
      list.classList.add('lv-faq-collapsed');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lv-faq-more';
      var label = isAr ? 'عرض كل الأسئلة (' + items.length + ')' : 'Show all questions (' + items.length + ')';
      var less = isAr ? 'عرض أقل' : 'Show less';
      btn.textContent = label;
      btn.addEventListener('click', function () {
        var open = list.classList.toggle('lv-faq-collapsed');
        btn.textContent = open ? label : less;
        if (open) list.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
      list.parentNode.insertBefore(btn, list.nextSibling);
      var box = list.parentNode.querySelector('input[class*="ai-faq-search-input"]');
      if (box) {
        box.addEventListener('input', function () {
          var typing = box.value.trim() !== '';
          list.classList.toggle('lv-faq-searching', typing);
          btn.style.display = typing ? 'none' : '';
        });
      }
    });
  }

  function initSort() {
    document.querySelectorAll('#MainContent .t4s_box_pr_grid').forEach(function (grid) {
      if (grid.closest('.flickityt4s, .flickity-enabled')) return;
      sortGrid(grid);
      placeMoreOptions(grid);
      new MutationObserver(function () {
        if (grid.__lvSorting) return;
        sortGrid(grid);
        placeMoreOptions(grid);
        boostLazy(grid);
      }).observe(grid, { childList: true });
    });
  }

  /* #4 Arabic: untranslated sort option. */
  function fixSortLabels() {
    if (!isAr) return;
    document.querySelectorAll('[data-livish-sort-value="most-relevant"]').forEach(function (b) {
      if (/most relevant/i.test(b.textContent)) b.textContent = 'الأكثر صلة';
    });
  }

  /* #13 Brand filter: search box for long lists. */
  function addFilterSearch() {
    document.querySelectorAll('.t4s-livish-filter__options').forEach(function (box) {
      var opts = box.querySelectorAll('.t4s-livish-filter__option');
      if (opts.length < 12 || box.querySelector('.lv-brand-search')) return;
      var input = document.createElement('input');
      input.type = 'search';
      input.className = 'lv-brand-search';
      input.placeholder = isAr ? 'ابحث عن ماركة' : 'Search brands';
      input.setAttribute('aria-label', input.placeholder);
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        opts.forEach(function (o) {
          o.hidden = q && o.textContent.toLowerCase().indexOf(q) < 0;
        });
      });
      input.addEventListener('click', function (e) { e.stopPropagation(); });
      box.insertBefore(input, box.firstChild);
    });
  }

  /* #9 Open the cart drawer after Add to Cart. */
  function openCartDrawer() {
    var link = document.querySelector('.t4s-toolbart-cart a[data-drawer-options], a[data-drawer-options*="mini_cart"]');
    if (link && !document.querySelector('#t4s-mini_cart[aria-hidden="false"]')) link.click();
  }
  function watchAddToCart() {
    if (window.__lvAtcWatch || !window.fetch) return;
    window.__lvAtcWatch = true;
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) { if (res && res.ok) setTimeout(openCartDrawer, 350); }).catch(function () {});
      }
      return p;
    };
  }
  watchAddToCart();

  /* #12 Desktop wishlist icon points to the working wishlist page. */
  function fixWishlistLinks() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    document.querySelectorAll('a[href$="/pages/wishlist"]').forEach(function (a) {
      a.setAttribute('href', root + 'search/?view=wishlist');
    });
  }

  /* #14 Cart text and footer typo (English). Arabic is fixed in translations. */
  function fixTexts(scope) {
    (scope || document).querySelectorAll('#t4s-footer h3, #t4s-footer h4, #t4s-footer .t4s-footer-heading, #t4s-footer [class*="heading"], #t4s-footer [class*="title"]').forEach(function (h) {
      if (h.childElementCount === 0 && /^\s*Infomation\s*$/.test(h.textContent)) h.textContent = 'Information';
    });
    if (isAr) return;
    (scope || document).querySelectorAll('.t4s-cart-total-tax, [class*="tax"], .t4s-mini_cart__tax, p, small, div').forEach(function (el) {
      if (el.childElementCount === 0 && /^\s*Taxes and shipping calculated at checkout\.?\s*$/.test(el.textContent)) {
        el.textContent = 'Delivery fee is shown at checkout';
      }
    });
  }
  function watchCartText() {
    var drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;
    new MutationObserver(function () { fixTexts(drawer); }).observe(drawer, { childList: true, subtree: true });
  }

  /* Language switch: go to this page's address in the other language. */
  function switchLanguage(iso, fallbackItem) {
    var alt = document.querySelector('link[rel="alternate"][hreflang="' + iso + '"]');
    if (alt) {
      var a = document.createElement('a');
      a.href = alt.href;
      location.href = a.pathname + location.search + location.hash;
      return;
    }
    var form = document.querySelector('form[action*="localization"]');
    var code = form && form.querySelector('input[name="language_code"], input[name="locale_code"]');
    if (!form || !code) { if (fallbackItem) fallbackItem.click(); return; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var base = root.replace(/\/$/, '');
    var path = location.pathname;
    if (base && path.indexOf(base) === 0) path = path.slice(base.length) || '/';
    code.value = iso;
    var back = form.querySelector('input[name="return_to"]');
    if (back) back.value = path + location.search;
    form.submit();
  }

  /* Header: small language button next to the menu icon (phone and tablet). */
  function addHeaderLang() {
    var menu = document.querySelector('.t4s-livish-desktop-menu__inner > .t4s-livish-dm__item--menu-toggle');
    if (!menu || menu.parentElement.querySelector('.lv-hdr-lang')) return;
    var iso = isAr ? 'en' : 'ar';
    if (!document.querySelector('link[rel="alternate"][hreflang="' + iso + '"]')) return;
    var item = document.createElement('div');
    item.className = 't4s-livish-dm__item lv-hdr-lang';
    var link = document.createElement('a');
    link.href = '#';
    link.className = 'lv-hdr-lang__btn';
    link.setAttribute('lang', iso);
    link.setAttribute('aria-label', isAr ? 'English' : 'العربية');
    link.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z"/></svg><span>' + (isAr ? 'EN' : 'ع') + '</span>';
    link.addEventListener('click', function (e) {
      e.preventDefault();
      switchLanguage(iso);
    });
    item.appendChild(link);
    menu.parentElement.insertBefore(item, menu.nextSibling);
  }

  /* Menu: one-tap language switch at the top of the mobile menu, next to
     the close button (the old switch sat below long category lists). */
  function addMenuLangToggle() {
    var drawer = document.getElementById('t4s-menu-drawer');
    if (!drawer) return;
    var head = drawer.querySelector('.t4s-mbcg-header');
    var items = drawer.querySelectorAll('.t4s-mbcg__localization [data-locale-item]');
    if (!head || !items.length || head.querySelector('.lv-lang-toggle')) return;
    var other = null;
    for (var i = 0; i < items.length; i++) {
      if (!items[i].classList.contains('is--selected')) { other = items[i]; break; }
    }
    if (!other) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lv-lang-toggle';
    btn.setAttribute('lang', other.getAttribute('data-iso') || '');
    btn.textContent = other.getAttribute('data-iso') === 'en' ? 'English' : 'العربية';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      switchLanguage(other.getAttribute('data-iso'), other);
    });
    head.appendChild(btn);
    drawer.classList.add('lv-has-lang-toggle');
  }
  function watchMenu() {
    var drawer = document.getElementById('t4s-menu-drawer');
    if (!drawer) return;
    addMenuLangToggle();
    new MutationObserver(addMenuLangToggle).observe(drawer, { childList: true, subtree: true });
  }

  /* Arabic: delivery date without the English "th", correct plural for
     hours and minutes, and Arabic name for loyalty points. */
  function arPlural(n, one, few, many) {
    n = parseInt(n, 10);
    return n + ' ' + (n >= 3 && n <= 10 ? few : (n >= 11 ? many : one));
  }
  function fixArabicText() {
    if (!isAr) return;
    document.querySelectorAll('[data-end-delivery]').forEach(function (el) {
      var t = el.textContent;
      var f = t.replace(/(\d+)(st|nd|rd|th)\b/g, '$1').replace(/,\s*/g, '، ');
      if (f !== t) el.textContent = f;
    });
    document.querySelectorAll('[data-hour-delivery]').forEach(function (el) {
      var t = el.textContent;
      var f = t.replace(/(\d+)\s*ساعات/g, function (m, n) { return arPlural(n, 'ساعة', 'ساعات', 'ساعة'); })
               .replace(/(\d+)\s*دقائق/g, function (m, n) { return arPlural(n, 'دقيقة', 'دقائق', 'دقيقة'); });
      if (f !== t) el.textContent = f;
    });
    document.querySelectorAll('a[href="#smile-home"] strong').forEach(function (el) {
      var t = el.textContent;
      var f = t.replace(/(\d[\d,]*)\s*Vee Points?/i, function (m, n) {
        var v = parseInt(n.replace(/,/g, ''), 10);
        return n + ' ' + (v >= 3 && v <= 10 ? 'نقاط' : 'نقطة') + ' ڤي';
      });
      if (f !== t) el.textContent = f;
    });
  }
  function watchArabicText() {
    if (!isAr || !window.MutationObserver) return;
    var queued = false;
    fixArabicText();
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; fixArabicText(); }, 120);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  ready(function () {
    initSort();
    fixSortLabels();
    addFilterSearch();
    fixWishlistLinks();
    fixTexts();
    watchCartText();
    watchMenu();
    addHeaderLang();
    watchMegaMenu();
    watchCarousels();
    watchLazy();
    if (document.readyState === 'complete') collapseFaqs();
    else window.addEventListener('load', collapseFaqs);
    watchArabicText();
  });
})();
